import React, { useState } from 'react';

import './styles.css';

import documentsServices from '../../../../services/academy/documentsServices';

import { Dots } from "react-activity";

import Popup from '../../../../components/Popup';
import Input from '../../../../components/Input';
import { FaRegFileAlt, FaRegFolder } from 'react-icons/fa';

function PopupNewDocument(props) {
    const [fileName, setFileName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    function changeSelectedFile(event) {
        setSelectedFile(event.target.files[0]);
        if (fileName === "") setFileName(event.target.files[0].name.split('.')[0]);
    }

    async function createDocument() {
        console.log(selectedFile);
        if (selectedFile && fileName) {
            setUploading(true);
            const response = await documentsServices.postAcademyDocument(selectedFile, fileName);
            setUploading(false);
            if (response.status === 201) {
                setTimeout(() => {
                    props.onCreate();
                    props.setVisibility(false);
                    setFileName("");
                    setSelectedFile(null);
                }, 500);
            } else
                alert("Erro ao enviar documento, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaRegFileAlt />}
            tittle='Novo documento'

        >
            <form action="" className='academy-new-document-form'>
                <Input
                    label='Título do documento*'
                    id='academy-new-document-file-name'
                    placeholder="Escreva aqui o título"
                    onChange={(event) => setFileName(event.target.value)}
                    value={fileName}
                />
                <Input
                    type='file'
                    accept='application/pdf'
                    className='academy-new-document-file-input'
                    id='academy-new-document-file'
                    label={selectedFile ? selectedFile.name : "Selecionar arquivo*"}
                    icon={<FaRegFolder />}
                    onChange={changeSelectedFile}
                />
                <button
                    type='button'
                    className='purple'
                    onClick={() => uploading ? alert("Um envio já está em andamento.") : createDocument()}
                >
                    {
                        uploading ?
                            <Dots />
                            : "Adicionar documento"
                    }
                </button>
            </form>
        </Popup>
    )
}

export default PopupNewDocument;